
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Popup from 'vux/src/components/popup/index.vue'


export default {
props: ['memberId'],
directives: {
TransferDom
},
components: {
XHeader,
Group,
Cell,
XButton,
XInput,
Popup
},
data() {
return {
member: {info: {}},
pageLoaded: false,
showTransfer: false,
showGet: false,
inputQuantity: '',
maxQuantity: 0,

maxReduceQuantity: 0,
inputReduceQuantity: '',

self: [],
child: [],
cateId: 0,
}
},
computed: {},
created: function () {
document.title = '向' + this.memberId + '转移库存';
this.$vux.loading.show({
'text': '加载中'
});
const url = this.tianYiWebUrl + '/wechat/uc/ajaxGetMemberStock';
this.$http.get(url, {params: {uid: this.memberId}}).then(r => {
let res = r.data;
if (res.code === 200) {
this.member.info = res.data.memberInfo;
this.self = res.data.self;
this.child = res.data.child;
this.pageLoaded = true;
this.$vux.loading.hide();
}
})
},
methods: {
jump(value) {
this.$router.push('/uc/promisebalancelist')
},
transfer(cateId) {
this.cateId = cateId;
let cateData = this.self.filter(function (item) {
if (item['product_cate_id'] === cateId)
return true;
});
this.maxQuantity = cateData[0]['amount'];
this.showTransfer = true;
},
reduce(cateId) {
this.cateId = cateId;
console.log(this.cateId)
let child = this.child.filter(function (item) {
if (item['product_cate_id'] === cateId)
return true;
});
this.maxReduceQuantity = child[0]['amount'];
this.showGet = true;
},
transferEye() {
},
transferSkin() {
this.maxQuantity = 200;
this.showTransfer = true;
},
submitTransfer() {
let value = parseInt(this.inputQuantity)
if (isNaN(value) || value <= 0) {
this.$vux.alert.show({
title: '输入错误',
content: '请输入正确的数量'
});
return;
}

if (value > parseInt(this.maxQuantity)) {
this.$vux.alert.show({
title: '库存不足',
content: '您的库存不足，不能完成转移。'
});
return;
}

this.$vux.loading.show({
text: 'Loading'
});
this.$http.get(this.tianYiWebUrl + '/wechat/uc/ajaxTransferStock', {
params: {
uid: this.memberId,
cate_id: this.cateId,
quantity: this.inputQuantity
}
}).then(r => {
let res = r.data;
if (res.code === 200) {
this.$vux.alert.show({
title: '成功了',
content: '成功向该代理转移了库存'
});
this.showTransfer = false;
window.location.href = '/html/uc/transfer-stock/' + this.memberId;
this.pageLoaded = true;
this.$vux.loading.hide();
}
})
},
submitReduce() {
let value = parseInt(this.inputReduceQuantity)
if (isNaN(value) || value <= 0) {
this.$vux.alert.show({
title: '输入错误',
content: '请输入正确的数量'
});
return;
}

if (value > parseInt(this.maxReduceQuantity)) {
this.$vux.alert.show({
title: '库存不足',
content: '您的库存不足，不能完成转移。'
});
return;
}

this.$vux.loading.show({
text: 'Loading'
});
const _this = this;
this.$http.get(this.tianYiWebUrl + '/wechat/pickup/ajaxReduceStock', {
params: {
uid: this.memberId,
cate_id: this.cateId,
quantity: this.inputReduceQuantity
}
}).then(r => {
let res = r.data;
if (res.code === 200) {
this.showTransfer = false;
this.$vux.loading.hide();
this.$vux.alert.show({
title: '成功发起请求',
content: res.message,
onHide() {
window.location.href = '/html/uc/transfer-stock/' + _this.memberId;
}
})
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/uc/TransferStock.vue